"use client";

import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { useUser } from "@clerk/clerk-react";
import { useOnboardingStore } from "../../lib/onboarding";
import { Input } from "@/components/ui/input";

const OnboardingStep1 = () => {
  const [, setLocation] = useLocation();
  const { user } = useUser();
  const { displayName, setDisplayName } = useOnboardingStore();
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (displayName) return;

    if (user?.firstName) {
      setDisplayName(user.firstName);
    } else if (user?.emailAddresses?.[0]?.emailAddress) {
      setDisplayName(user.emailAddresses[0].emailAddress.split('@')[0]);
    }
  }, [user, displayName, setDisplayName]);

  const handleNext = () => {
    setTouched(true);
    if (!displayName?.trim()) {
      return;
    }
    setLocation("/onboarding/step-2");
  };

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-slate-900 font-display">Welcome to HiPo! What should we call you?</h2>
        <p className="mt-2 text-slate-600">This will be your name inside the HiPo platform.</p>
      </div>

      <div className="space-y-4">
        <div>
          <label htmlFor="display-name" className="block text-sm font-medium text-slate-700 font-sans">Display Name</label>
          <Input
            id="display-name"
            value={displayName ?? ''}
            onChange={(e) => setDisplayName(e.target.value)}
            placeholder="e.g. Alex"
            className="mt-1"
          />
        </div>
        {touched && !displayName?.trim() && (
          <p className="text-sm text-red-600">Please enter a display name to continue.</p>
        )}
      </div>

      <div className="flex justify-end pt-4">
        <button
          type="button"
          onClick={handleNext}
          className="inline-flex items-center justify-center px-6 py-2 border border-transparent text-base font-medium rounded-md shadow-sm bg-primary !text-primary-foreground hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary font-display"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default OnboardingStep1;
